import { Platform } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Box, Divider, HStack, VStack } from 'native-base';

import { SiteConfigDto } from '@pimm/services/lib/sms-tenants';
import { InfoCircleIcon } from '@pimm/base';
import { ReadOnlyField } from './read-only-field';
import Section from './section';

export const SiteInfoBlock = ({ site }: { site: SiteConfigDto }) => {
  const { t } = useTranslation();
  const brandName = site.companyInfo?.brand?.fullName || site.companyInfo?.brand?.name || '—';

  return (
    <Section.Card variant="form" title={t('store_settings:site_information')} icon={<InfoCircleIcon size={4} color="gray.700" />}>
      <VStack space={4}>
        <HStack space={6} flexWrap="wrap">
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:site_name')} value={site.name} />
          </Box>
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:store_number')} value={site.stopId} />
          </Box>
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:customer_code')} value={site.companyInfo?.chainName} />
          </Box>
          <Box flex={1} minW={Platform.OS === 'web' ? undefined : 170} />
        </HStack>

        <Divider />

        <HStack space={6} flexWrap="wrap">
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:brand')} value={brandName} />
          </Box>
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:customer_name')} value={site.companyInfo?.customerName} />
          </Box>
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:consolidation')} value={site.companyInfo?.consolidationName} />
          </Box>
          <Box flex={1} minW={Platform.OS === 'web' ? undefined : 170} />
        </HStack>
      </VStack>
    </Section.Card>
  );
};
